<div class="unit-chip"
     [ngClass]="{
     'bg-collection': unit.collection,
     'bg-create-new': unit.createNew }">
  <img *ngIf="unit.imageURL" [src]="unit.imageURL" class="unit-chip__image" [alt]="unit.username"/>
  <bulb-user-avatar
    *ngIf="!unit.imageURL && unit.displayProps"
    [displayProps]="unit.displayProps"
    class="unit-chip__image"
  ></bulb-user-avatar>
  <span class="unit-chip__label"
        [ngClass]="{
        'font-small' : unit.collection || unit.createNew
        }">{{ unit.username || unit.displayName || unit.name }}</span>
  <svg-icon *ngIf="isInherited" key="lock-alt"></svg-icon>
</div>
